import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FACTURE_DOSSIER_URL, GET_FACTURES_DOSSIER_URL, MAKE_FACTURE_URL } from "../../settings/APISetting";
import api from "../../config/axiosConfig";

export const fetchFacturesForDossier = createAsyncThunk('fetch-factures-dossier', async (dossierId) => {
    const response = await api.get(GET_FACTURES_DOSSIER_URL(dossierId));
    return response.data;
});

export const fetchFactureForDossier = createAsyncThunk('fetch-facture-dossier', async (fid) => {
    const response = await api.get(`${FACTURE_DOSSIER_URL}/${fid}`);
    return response.data;
});

export const createFactureDossier = createAsyncThunk('create-facture-dossier', async (facture) => {
    const response = await api.post(MAKE_FACTURE_URL, facture);
    return response.data;
});

export const updateFactureDossier = createAsyncThunk('update-facture-dossier', async (facture) => {
    const response = await api.post(MAKE_FACTURE_URL, facture);
    return response.data;
});

export const fetchFactureDossier = createAsyncThunk('fetch-facture-dossier', async (id) => {
    const response = await api.get(`${FACTURE_DOSSIER_URL}/${id}`);
    return response.data;
});

const facturesDossierSlice = createSlice({

    name: 'facturesDossier',
    initialState: { factures: [], factureFetchStatus: '' },

    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchFacturesForDossier.fulfilled, (state, action) => {

            state.factures = action.payload;
            state.factureFetchStatus = 'success';
        }).addCase(fetchFacturesForDossier.pending, (state, action) => {
            state.factureFetchStatus = 'loading';

        }).addCase(fetchFacturesForDossier.rejected, (state, action) => {

            state.factureFetchStatus = 'error';

        });
    }


});
export default facturesDossierSlice;